import { createTransform } from 'redux-persist'
import { CompanyPlanningRecordState, initialState } from './companyPlanningRecordSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  CompanyPlanningRecordState,
  Omit<CompanyPlanningRecordState, 'error'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: CompanyPlanningRecordState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      status,
    }
  },
  {
    whitelist: ['companyPlanningRecord'],
  },
)
